import {CodeEntry} from "./../../types/support/index";
import {ResponseResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {ReadProductGroupApiResponse} from "../../types/support/faq";

export interface ReadProductCategoryApiProps {
  keyword: string;
  keywordType: number;
  pageNo: number;
  limit: number;
  topicTypeList: string[];
}

const url = "api/customer/support/";

/**
 * 제품카테고리 목록 불러오기
 * @returns
 */
export async function readProductCategoryApi(): Promise<
  ResponseResType<{ CodeEntriesList: CodeEntry[] }>
> {
  const response = await baseApi.post(url + "read_product_category");

  return response?.data;
}

/**
 * 제품벤더 목록 불러오기
 * @returns
 */
export async function readProductVendorApi(): Promise<
    ResponseResType<{ CodeEntriesList: CodeEntry[] }>
> {
  const response = await baseApi.post(url + "read_product_vendor");

  return response?.data;
}


/**
 * 지원유형 목록 불러오기
 * @returns
 */
export async function readTopicTypeApi(): Promise<
    ResponseResType<{ CodeEntriesList: CodeEntry[] }>
> {
  const response = await baseApi.post(url + "read_topic_type");

  return response?.data;
}

/**
 * 제품군 목록 불러오기
 * @returns
 */
export async function readProductGroupApi(): Promise<
    ResponseResType<{ ProductGroupList: ReadProductGroupApiResponse[] }>
> {
  const response = await baseApi.post(url + "read_product_group");

  return response?.data;
}

/**
 * 지원유형 생성하기
 * @returns
 */
export async function createTopicTypeApi(codeEntriesName: string): Promise<
    ResponseResType<any>
> {
  const response = await baseApi.post(url + "create_topic_type", {codeEntriesName});

  return response?.data;
}


/**
 * 지원유형 삭제하기
 * @returns
 */
export async function deleteTopicTypeApi(idx: number): Promise<
    ResponseResType<any>
> {
  const response = await baseApi.post(url + "delete_topic_type", {idx});

  return response?.data;
}


/**
 * 지원유형 수정하기
 * @returns
 */
export async function updateTopicTypeApi(idx: number, codeEntriesName: string): Promise<
    ResponseResType<any>
> {
  const response = await baseApi.post(url + "update_topic_type", {idx, codeEntriesName});

  return response?.data;
}

